import { Button } from 'reactstrap';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const StandardLayout = ({
  pageTitle,
  headerButton,
  children,
  showBackButton,
  onBackClick,
}: {
  pageTitle: string;
  headerButton?: React.ReactNode | null;
  children: React.ReactNode;
  showBackButton?: boolean;
  onBackClick?: () => void;
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <div className="page-content">
        <div className="w-100 d-flex justify-content-between align-items-center mb-3 flex-row gap-2">
          <div className="d-flex align-items-center justify-content-start gap-1">
            {showBackButton && (
              <Button color="link" onClick={handleBackClick}>
                <FaArrowLeft size={24} />
              </Button>
            )}
            <h3 className="mb-0 text-2xl font-bold">{pageTitle}</h3>
          </div>
          {headerButton}
        </div>
        {children}
      </div>
    </>
  );
};

export default StandardLayout;
